export enum CmpConfigPropertiesField {
    CREATION_TYPE = "creation_type"
}
